/* unplugin-vue-components disabled */import { render } from "./xModal.vue?vue&type=template&id=6155cc7f&scoped=true"
import script from "./xModal.vue?vue&type=script&lang=jsx"
export * from "./xModal.vue?vue&type=script&lang=jsx"

import "./xModal.vue?vue&type=style&index=0&id=6155cc7f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6155cc7f"]])

export default __exports__